import React, { useMemo, memo } from 'react';
import PropTypes from 'prop-types';
import { TableCell } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faMinus } from '@fortawesome/free-solid-svg-icons';

function TableListerCell({
  value, type, onContextMenu, choices, sx,
}) {
  const dChoices = useMemo(
    () => {
      if (!Array.isArray(choices)) {
        return null;
      }
      return choices.reduce((R, c) => ({ ...R, [c.value]: c.display_name }), {});
    },
    [choices],
  );

  const displayValue = useMemo(
    () => {
      if (dChoices) {
        if (!value) return '';
        return dChoices[value] || '???';
      }
      if (type === 'nested object') {
        return value && value.repr;
      }
      if (type === 'decimal') {
        if (!value) return '';
        return parseFloat(value).toFixed(2);
      }
      if (type === 'date') {
        if (!value) return '';
        const d = new Date(value);
        return d.toLocaleString('uk', {
          day: '2-digit', month: '2-digit', year: 'numeric',
        });
      }
      if (type === 'datetime') {
        if (!value) return '';
        const d = new Date(value);
        return d.toLocaleString('uk', {
          day: '2-digit',
          month: '2-digit',
          year: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        });
      }
      if (type === 'boolean') {
        if (value) {
          return (
            <FontAwesomeIcon icon={faCheck} color="green" />
          );
        }
        return (<FontAwesomeIcon icon={faMinus} color="gray" />);
      }
      return value;
    },
    [dChoices, type, value],
  );
  return (
    <TableCell
      className={type}
      title={typeof displayValue === 'string' ? displayValue : ''}
      onContextMenu={onContextMenu}
      sx={sx}
    >
      <span>{displayValue}</span>
    </TableCell>

  );
}

const valuePropType = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.number,
  PropTypes.bool,
  PropTypes.shape({
    id: PropTypes.number,
    repr: PropTypes.string,
  }),
]);

TableListerCell.propTypes = {
  value: valuePropType,
  choices: PropTypes.arrayOf(PropTypes.shape({
    value: valuePropType,
    display_name: PropTypes.string,
  })),
  type: PropTypes.oneOf([
    'string', 'email', 'url', 'integer', 'float', 'decimal', 'choice', 'date', 'datetime', 'nested object', 'boolean', 'field',
  ]),
  onContextMenu: PropTypes.func.isRequired,
  sx: PropTypes.shape({}),
};

TableListerCell.defaultProps = {
  value: null,
  type: 'string',
  choices: null,
  sx: {},
};

export default memo(TableListerCell);
